import { render, staticRenderFns } from "./EntrepreneurshipNeed.vue?vue&type=template&id=27833772"
import script from "./EntrepreneurshipNeed.vue?vue&type=script&lang=js"
export * from "./EntrepreneurshipNeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports